import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Info_Spring from '../../component/Spring/Info_Spring';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';
import AccountList2 from '../../component/Account/AccountList2';
import musicTitle from '../../asset/music/yunhwa.mp3'

const SonYunHwa = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "유경재 ♥ 손윤화 결혼합니다.";
    const openDesc = "10월 19일 일요일 오후 12시 30분";
    const openThumb = "https://d39wt6wnedokd1.cloudfront.net/250/thumb.jpg";

    const lng = 126.82672715031698;
    const lat = 37.56716749667853;

    const placeTelNum = "02-2662-8300";

    const forCar = "네비게이션 : '보타닉파크웨딩 주차장' 또는 '마곡동 760' \n입력\n\n · 외곽순환도로\n김포대로(김포공항방면) → 공항사거리 좌회전(신방화역 \n방면) → 마곡나루역\n\n · 올림픽대로(고속도로 이용)\n김포공항방면 → 발산역 방면 도시고속도로 출구 \n→ 양천항교역 우회전(서남물재생센터 방면) \n→ 마곡나루역 방면 좌회전 → 마곡중앙 5로 우회전(방화로 방면)\n\n · 남부순환로\n신월IC → 강서면허시험장 우회전(마곡역 방면) \n→ 마곡나루역 삼거리 좌회전(방화로 방면)";
    const forBus = "마곡나루역 정류장 하차\n·   좌석버스 9731 \n·   지선버스 6642, 6645, 6648 \n·   마을버스 강서05-1, 강서07";
    const forSubway = " ·  9호선 - 마곡나루역 1, 2번 출구방면 진입통로 연결\n  ·  공항철도 - 9호선 환승역 방향 마곡나루역 1, 2번 출구\n    방면 진입통로 연결";

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 연올리브
        concept: "SUMMER",
        titleColor: "#76902F",
        pointColor: "#76902F",
        btnBgColor: "#76902F",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }
    // const conceptStyle = {
    //     // summer 올리브
    //     concept: "SUMMER",
    //     titleColor: "#405200",
    //     pointColor: "#405200",
    //     btnBgColor: "#405200",
    //     fontColor: "#fff",
    //     btnFontColor: "#fff",
    //     chatBgColor: "#F5F8FF",
    //     fontFamilyKo: "SCDream3",
    //     fontFamilyEn: "Edensor"
    // }

    const title = "시월의 어느 가을날, 결혼합니다."

    const msg1 = "있는 그대로 사랑하고\n서로의 존재를 감사하며";
    const msg2 = "곁에 있을 때 가장 나다운 모습이 되게 하는사람과\n앞으로의 모든 계절을 함께 하고자 합니다.";
    const msg3 = "시월의 어느 가을날,\n늘 곁에서 아껴주었던 고마운 분들을 모십니다.\n저희 두사람이 사랑의 이름으로 지켜나갈 수 있게\n앞날을 축복해 주시면 감사하겠습니다.\n\n";

    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "유경재",
            bank: "우리은행",
            accountNumber : "1002-264-318374",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/Ej862QZN8"
        }
        ,{
            role: "신랑 부",
            name: "유세명",
            bank: "농협",
            accountNumber : "351-0752-6877-53",
            isKakao : false
        }
        ,{
            role: "신랑 모",
            name: "김병순",
            bank: "우리은행",
            accountNumber : "1002-444-657162",
            isKakao : false
        }
    ]

    const brideAccountList = [
        {
            role: "신부",
            name: "손윤화",
            bank: "신한은행",
            accountNumber : "110-524-354186",
            isKakao : true,
            kakaoUrl : "https://qr.kakaopay.com/FXb7sgo0i"
        }
        // ,{
        //     role: "신부 부",
        //     name: "홍성민",
        //     bank: "부산은행",
        //     accountNumber : "064-1211-08793",
        //     isKakao : false
        // }
        ,{
            role: "신부 모",
            name: "김다연",
            bank: "우리은행",
            accountNumber : "1002-929-183666",
            isKakao : false
        }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "우리의 설레였던 첫 만남 기억해?",
            groomAnswer: "너무 예뻤어",
            brideAnswer: "어떻게 잊어"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "너무 기대돼",
            brideAnswer: "설레 죽겠다"
        },
        {
            question : "서로에게 하고 싶은 말은?",
            groomAnswer: "많이 사랑해",
            brideAnswer: "나도 사랑해"
        },
        {
            question : "유부남/녀 기념 각오 한마디!",
            groomAnswer: "잘해줄게요",
            brideAnswer: "행복합시다"
        },
        {
            question : "마지막으로 전하고 싶은 이야기는?",
            groomAnswer: "축하해줘요",
            brideAnswer: "많이많이♥"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "이상현",
            call: "010-5048-1259"
        }
        ,{
            role: "신랑 부",
            name: "이용우",
            call: "010-4103-1248"
        }
        ,{
            role: "신랑 모",
            name: "이영실",
            call: "010-7137-1248"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "조아인",
            call: "010-6389-6551"
        }
        ,{
            role: "신부 부",
            name: "조양주",
            call: "010-3789-6551"
        }
        ,{
            role: "신부 모",
            name: "박은영",
            call: "010-9040-6551"
        }
    ]

    const informationList =[
        {
            title : "ATM 기기 안내",
            content : "주변엔 ATM기기가 없습니다. \n이점 양해 부탁드립니다."
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
        // #76902F
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#76902F"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} musicTitle={musicTitle}/>
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#76902F"} letteringFontColor={"#76902F"} dateColor={"#76902F"} bottom={"30%"} bottom2={"20.5%"} dateBottom={"1%"} top={"3%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2  weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={getFirstEnName(weddingData.brideNameEn)} groomNameEn={getFirstEnName(weddingData.groomNameEn)}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    {/* <CallInfo marginTop={"10px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/> */}
                    <Dday_Spring brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <Message_Spring  weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forCar={forCar} forBus={forBus} forSubway={forSubway} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default SonYunHwa;